export const HeardAboutMixin = {
  data() {
    return {
      items: [
        { value: 0, text: '' },
        { value: 1, text: 'heard-about-participated-last-year' },
        { value: 2, text: 'heard-about-facebook' },
        { value: 3, text: 'heard-about-instagram' },
        { value: 4, text: 'heard-about-linkedIn' },
        { value: 5, text: 'heard-about-newspaper' },
        { value: 6, text: 'heard-about-electronic-newspaper' },
        { value: 7, text: 'heard-about-advertisement-newspaper' },
        { value: 8, text: 'heard-about-advertisement-electronic-newspaper' },
        { value: 9, text: 'heard-about-advertisement-internet' },
        { value: 10, text: 'heard-about-friends-coworkers' },
        { value: 11, text: 'heard-about-family' },
        { value: 12, text: 'heard-about-school' },
        { value: 13, text: 'heard-about-radio' },
        { value: 14, text: 'heard-about-television' },
        { value: 15, text: 'heard-about-other' }
      ],
      textItems: [
        { value: 'none', text: '' },
        { value: 'participatedLastYear', text: 'heard-about-participated-last-year' },
        { value: 'facebook', text: 'heard-about-facebook' },
        { value: 'instagram', text: 'heard-about-instagram' },
        { value: 'linkedIn', text: 'heard-about-linkedIn' },
        { value: 'newspaper', text: 'heard-about-newspaper' },
        { value: 'electronicNewspaper', text: 'heard-about-electronic-newspaper' },
        { value: 'advertisementNewspaper', text: 'heard-about-advertisement-newspaper' },
        { value: 'advertisementElectronicNewspaper', text: 'heard-about-advertisement-electronic-newspaper' },
        { value: 'advertisementInternet', text: 'heard-about-advertisement-internet' },
        { value: 'friendsCoworkers', text: 'heard-about-friends-coworkers' },
        { value: 'family', text: 'heard-about-family' },
        { value: 'school', text: 'heard-about-school' },
        { value: 'radio', text: 'heard-about-radio' },
        { value: 'television', text: 'heard-about-television' },
        { value: 'other ', text: 'heard-about-other' }
      ]
    }
  },
  methods: {
    getHeardAbout: function(item) {
      return this.items[item].text
    }
  }
}
